import { CurrentSolutionSetup } from './currentSolutionSetup';
import { SolutionEquipment } from './solutionEquipment';
import { SolutionProvider } from './solutionGateway';
import { SolutionPaymentCollectionMethod } from './solutionPaymentCollectionMethod';
import { SolutionPricing } from './solutionPricing';

export class SolutionDetails {
  id: string | undefined;
  currentSetup: CurrentSolutionSetup | undefined;
  ach: SolutionProvider | undefined;
  equipment: SolutionEquipment[] = [];
  equipmentNeeded: boolean | undefined;
  gateway: SolutionProvider | undefined;
  paymentCollectionMethods: SolutionPaymentCollectionMethod[] = [];
  pricing: SolutionPricing | undefined; // proposed pricing

  // services:SolutionServiceItem[] = [];
  // services:SolutionServiceItem[] = [];
  // gateways:SolutionGateway[] = [];
  // cardRates:SolutionCardRate[] = [];

  constructor(s: Partial<SolutionDetails>) {
    this.id = s.id;
    this.equipmentNeeded = s.equipmentNeeded;
    this.pricing = s.pricing;
    this.currentSetup = s.currentSetup;
    this.ach = s.ach;
    this.equipment = s.equipment || [];
    this.gateway = s.gateway;
    this.paymentCollectionMethods = s.paymentCollectionMethods || [];
  }
}
